// extracted by mini-css-extract-plugin
module.exports = {"logo":"login_logo__35AYm","history":"login_history__ejPpY","container":"login_container__1MywV","slideLeft":"login_slideLeft__KC6bB","slideMove":"login_slideMove__2vY_9"};